import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select } from "react-spark";

import "./_select.scss";
import {
    optionsPropTypes,
    withValidationOutputDefaultProps,
    withValidationOutputPropTypes,
    sharedFormInputPropTypes,
    sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class URCSelect extends Component {
    constructor(props) {
        super(props);

        this._cleanOptions();
    }

    componentDidMount() {
        this.props.context.registerFormElement({
            value: this.props.value,
            name: this.props.name,
            valid: this.props.validateOnRegisterUpdate.apply(this),
            validate: this.props.handleValidation,
            handleChange: this.props.handleChange,
            dependentFields: this.props.dependentFields
        });
    }

    componentDidUpdate() {
        if (this.props.forceUpdate) {
            this.props.context.updateFormElement({
                value: this.props.value,
                name: this.props.name,
                valid: this.props.validateOnRegisterUpdate.apply(this)
            });
        }
    }

    componentWillUnmount() {
        this.props.context.deregisterFormElement({
            name: this.props.name,
        }, this);
    }

    _cleanOptions() {
        const { options, usePlaceholderOption, placeholderText } = this.props;
        const resolvedOptions = _.cloneDeep(options);

        if (usePlaceholderOption) {
            resolvedOptions.unshift({
                disabled: true,
                value: "",
                text: placeholderText || "Choose one"
            });
        }

        this.options = resolvedOptions;
    }

    render() {
        const {
            className,
            context,
            disabled,
            errorMessage,
            handleBlur,
            handleChange,
            helper,
            id,
            name,
            placeholder,
            validation,
            value
        } = this.props;

        return (
            <Select
                className={className}
                disabled={disabled}
                error={errorMessage}
                helper={helper}
                id={id}
                label={placeholder}
                name={name}
                onChange={e => handleChange(e, context)}
                onBlur={e => handleBlur(e, context.handleChange)}
                options={this.options}
                required={validation.required}
                value={value}
            />
        );
    }
}

URCSelect.defaultProps = {
    ...withValidationOutputDefaultProps,
    ...sharedFormInputDefaultProps,
    usePlaceholderOption: false,
    value: ""
};

URCSelect.propTypes = {
    ...optionsPropTypes,
    ...withValidationOutputPropTypes,
    ...sharedFormInputPropTypes,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    usePlaceholderOption: PropTypes.bool
};

export default withValidation(URCSelect, { type: "select" });
